import discardBlockedSendersOption from './actions/discardBlockedSendersOption';
import saveBlockedSendersOption from './actions/saveBlockedSendersOption';
import BlockedSendersFull from './components/BlockedSendersFull';
import isBlockedSendersOptionDirty from './utils/isBlockedSendersOptionDirty';
import * as React from 'react';
var BlockedSendersOption = {
    key: 'blockedSenders',
    titleStringKey: 'optionTitle_blockedSenders',
    searchTermsStringKey: 'optionSearchTerms_blockedSenders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(BlockedSendersFull, null); },
        isDirty: isBlockedSendersOptionDirty,
        onSave: saveBlockedSendersOption,
        onDiscard: discardBlockedSendersOption,
    },
};
export default BlockedSendersOption;
//# sourceMappingURL=BlockedSendersOption.js.map